
export default (t) => [
  {
    text: t('Branch Name'),
    value: 'name',
    sortable: false
  },
  {
    text: t('Status'),
    value: 'status',
    sortable: false,
    width: 150
  },
  {
    text: t('Pending Orders'),
    value: 'count_orders',
    sortable: false,
    width: 200
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 150
  },
];
